/*
 * ModifierIndicator
 * Componente visual para mostrar estado de teclas modificadoras activas
 */

import React from 'react';
import { Box, Chip, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { ModifierState } from '@/hooks/useModifierKeys';

interface ModifierIndicatorProps {
  modifiers: ModifierState;
}

export const ModifierIndicator: React.FC<ModifierIndicatorProps> = ({ modifiers }) => {
  const hasActiveModifiers = modifiers.ctrl || modifiers.alt || modifiers.shift || modifiers.meta;

  if (!hasActiveModifiers) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={(theme) => ({
          backgroundColor:
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.common.black, 0.7)
              : alpha(theme.palette.common.white, 0.9),
          backdropFilter: 'blur(8px)',
          borderRadius: 2,
          px: 2,
          py: 1,
          border: `1px solid ${theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.12) : alpha(theme.palette.common.black, 0.06)}`,
        })}
      >
        {modifiers.ctrl && (
          <Chip
            label="Ctrl"
            size="small"
            color="primary"
            sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}
          />
        )}
        {modifiers.alt && (
          <Chip
            label="Alt"
            size="small"
            color="primary"
            sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}
          />
        )}
        {modifiers.shift && (
          <Chip
            label="Shift"
            size="small"
            color="primary"
            sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}
          />
        )}
        {modifiers.meta && (
          <Chip
            label="Win/Cmd"
            size="small"
            color="primary"
            sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}
          />
        )}
      </Stack>
    </Box>
  );
};
